<template>
  <div>
    <v-layout wrap justify-center pt-10>
      <v-flex xs12 sm12 md12 lg12>
        <v-layout wrap justify-center style="background-color: #3d673a;">
          <v-flex xs12 sm12 md11 lg11>
            <v-layout wrap justify-center pa-6>
              <v-flex xs12>
                <h2 class="text-center text-bold" style="color:#ffcf59;font-size:40px;font-family:poppinsbold">Alumni Testimonials</h2>
              </v-flex>
              
              <v-flex xs12 sm6 md4 lg3 v-for="(alumni, index) in alumniList" :key="index" class="pa-4">
                <v-card class="pa-4 d-flex flex-column justify-space-between" style="background-color: #ffcf59; height: 100%;">
                  <!-- Content Section -->
                  <div>
                    <v-avatar color="white" size="90" class="mx-auto mb-4">
                      <v-icon size="64" color="#3d673a">mdi-account</v-icon>
                    </v-avatar>
    
                    <h3 class="text-left text-bold" style="color:#3d673a;font-family:poppinsbold">{{ alumni.name }}</h3>
                    <h3 style="color:#3d673a;font-family:poppinsbold" class="text-left mb-1 text-bold">{{ alumni.cohort }}</h3>
                    <p style="color:grey;font-family:poppinsregular" class="text-left">{{ alumni.designation }}</p>
                  </div>
    
                  <!-- Button Section -->
        <div class="mt-auto">
          <v-btn
            block
            style="background-color: #3d673a;"
            text
            @click="openVideo(alumni.videoLink)"
          >
            <span style="color: #ffcf59; text-decoration:underline">Watch Video</span>
          </v-btn>
        </div>
                </v-card>
              </v-flex>
    
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
       <!-- Video Dialog -->
    <v-dialog v-model="showVideo" width="70%" persistent>
      <v-card>
        <v-card-title class="headline">Watch Video</v-card-title>
        <v-card-text>
          <iframe
            v-if="currentVideo"
            :src="currentVideo"
            width="100%"
            height="400"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeVideo">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alumniList: [
        {
          name: "Karishma Pradhan",
          cohort: "2017–2019 Cohort",
          designation: "Project Manager, Eastern Himalaya, NCF",
          image: require("../assets/Images/account.jpg"),
          videoLink: "https://www.youtube.com/embed/g3bih-FdF5I",
        },
        {
          name: "Sharath Anchatageri",
          cohort: "2018–2020 Cohort",
          designation: "Associate Coordinator, WWF-India",
          image: "path-to-sharath-image.jpg",
          videoLink: "https://www.youtube.com/embed/4XuuM3-SA_4",
        },
        {
          name: "Aswathi Asokan",
          cohort: "2022–2024 Cohort",
          designation:
            "Teaching and Learning Facilitator, Youth Conservation Action Network",
          image: "path-to-aswathi-image.jpg",
          videoLink: "https://www.youtube.com/embed/pr1EJCB4dSk",
        },
        {
          name: "Jayaram Sheshadri",
          cohort: "2022–2024 Cohort",
          designation: "Research Associate, IORA Ecological Solution",
          image: "path-to-jayaram-image.jpg",
          videoLink: "https://www.youtube.com/embed/pg2yxWwH5wI",
        },
      ],
      showVideo: false,
      currentVideo: null,
    };
  },
  methods: {
    openVideo(videoLink) {
      this.currentVideo = videoLink;
      this.showVideo = true;
    },
    closeVideo() {
      this.showVideo = false;
      this.currentVideo = null;
    },
  },
};
</script>
<style scoped>
.text-bold {
  font-weight: bold;
}
</style>
